<template>
  <div class="l-learn-swiper-container l-common-container" v-if="element">
    <LSwiper
      :swiperData="element.attrs.imageList"
      :swiperIndex="swiperIndex"
      @slidechange="onSlideChange"
    />
    <LButtonCommon class="l-btn-submit" v-show="isShowSwiperBtn" @select="onEnd" :type="3" />
  </div>
</template>

<script>
import LSwiper from '../../components/l-swiper'
import LButtonCommon from '@/views/learn-new/components/l-button-common'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-swiper',
  components: { LSwiper, LButtonCommon },
  data() {
    return {
      swiperIndex: 0, // 索引值
      isShowSwiperBtn: false,
      LOCAL_KEY: 'SWIPER',
      currentLocalKey: '',
    }
  },
  computed: {
    ...mapGetters(['element']),
  },
  watch: {
    'element.ELEMENT_TYPE'(to) {
      if (to) {
        // 判断本地缓存
        this.currentLocalKey = `${this.LOCAL_KEY}_${this.element.RECORD_ID}`
        if (localStorage.getItem(this.currentLocalKey)) {
          const params = JSON.parse(localStorage.getItem(this.currentLocalKey))
          this.swiperIndex = params.index
          this.isShowSwiperBtn = params.isShowSwiperBtn
        }
      }
    },
    // 监听提交完成
    'element.isSubmit'(to) {
      if (to) {
        localStorage.removeItem(this.currentLocalKey)
        this.$emit('next')
      }
    },
  },
  methods: {
    // 轮播图切换事件
    onSlideChange(data) {
      if (data.index + 1 == data.length) {
        this.isShowSwiperBtn = true
      }
      const params = {
        index: data.index,
        isShowSwiperBtn: this.isShowSwiperBtn,
      }
      // 缓存userid+元素id
      localStorage.setItem(this.currentLocalKey, JSON.stringify(params))
    },
    // 点击继续学习
    onEnd() {
      this.$emit('submit')
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
@import '../../style/l-btn.styl'
</style>
